import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaTimes } from "react-icons/fa";

const FloatingCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  // Slide in after a slight delay
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 10000);
    return () => clearTimeout(timer);
  }, []);

  if (dismissed) return null;

  return (
    <div
      className={`fixed bottom-5 right-5 z-50 transition-all duration-500 ease-in-out transform ${
        isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"
      } hidden md:flex items-center bg-mmSurface/90 border border-mmAccent text-mmAccent rounded-lg px-4 py-2 shadow-sm gap-3 backdrop-blur-sm`}
    >
      <Link
        to="/voorbereiding-check"
        className="flex items-center gap-2 font-semibold transition-all hover:text-mmAccentHover"
      >
        Doe de gratis voorbereidings-check
      </Link>
      <button
        onClick={() => setDismissed(true)}
        className="ml-1 text-mmAccent/80 hover:text-mmAccentHover transition"
        aria-label="Dismiss CTA"
      >
        <FaTimes size={14} />
      </button>
    </div>
  );
};

export default FloatingCTA;
